// language: javascript
// assets/scrollout-init.js
// Initialize the local scroll-out (assets/scroll-out.min.js) and target .section-wrapper .section > *
// - Uses the global ScrollOut provided by scroll-out.min.js (non-module build)
// - Respects prefers-reduced-motion
// - Adds .so-visible when an element is shown

console.log('Initializing ScrollOut (local build)');

const initScrollOut = () => {
  // Disable when in Shopify theme editor / customizer
  // - Shopify provides a global flag `Shopify.designMode` in the editor.
  // - As a fallback you can set a Liquid-provided global (see notes below).
  if ((window.Shopify && window.Shopify.designMode) || window.__SHOPIFY_DESIGN_MODE === true) {
    // Reveal everything immediately in the customizer so authors see content without animations
    document.querySelectorAll('.section-wrapper .section > *').forEach((el) => el.classList.add('so-visible'));
    return;
  }
  // Respect reduced motion
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    document.querySelectorAll('.section-wrapper .section > *').forEach((el) => el.classList.add('so-visible'));
    return;
  }

  // If ScrollOut is available as a global (from assets/scroll-out.min.js), use it.
  if (typeof ScrollOut !== 'function') {
    console.warn('ScrollOut global not found — falling back to immediate reveal');
    document.querySelectorAll('.section-wrapper .section > *').forEach((el) => el.classList.add('so-visible'));
    return;
  }

  // Initialize ScrollOut targeting child divs inside .section
  ScrollOut({
    targets: '.section-wrapper .section > *',        // elements to observe
    cssProps: true,             // set data-scroll/out properties as CSS props
    threshold: 0.12,            // when to trigger
    once: true,                 // reveal once
    // onShown would run for each show. We add class via onShown if you want custom behavior.
    onShown: (el) => {
      el.classList.add('so-visible');
    },
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollOut);
} else {
  initScrollOut();
}